export function tagPromoterChannelFcWorksLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_PROMOTER_CHANNEL_FC_WORKS_LOADING',
    tagPromoterChannelFcWorks: resp,
    store
  };
}

export function tagPromoterChannelFcWorksLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_PROMOTER_CHANNEL_FC_WORKS_LOADED',
    tagPromoterChannelFcWorks: {
      channelFcWorksPosts: resp.posts,
      source: resp.source
    },
    store
  };
}

export function tagPromoterChannelFcWorksError(error, store = {}) {
  return {
    type: 'TAG_PROMOTER_CHANNEL_FC_WORKS_ERROR',
    tagPromoterChannelFcWorks: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
